import { EtlSummaryTileVariant } from "./etl-summary.models";

/** Positional colours for up to 3 domain tiles; the Load Duration tile is always Duration (orange). */
export const ETL_SUMMARY_DOMAIN_VARIANTS: EtlSummaryTileVariant[] = [
  EtlSummaryTileVariant.Existing,
  EtlSummaryTileVariant.New,
  EtlSummaryTileVariant.Removed,
];
